<template>
  <BaseModal name="product-co-sellers" size="md" :title="isObjectEmpty(selectedCoseller) ? $t('seller.products.co_seller.text_327') : $t('seller.products.co_seller.edit_co_seller_comission')">
    <b-row>
      <h5 class="produto-nome">• {{ product_id.name }}</h5>
      <b-col cols="12" v-if="!loading">
        <b-form novalidate>
          <b-row class="item-campos">
            <b-col cols="12">
              <b-form-group
                :label="$t('seller.products.co_seller.text_328')"
                label-for="coProdutor_email"
                data-vv-scope="coProdutor_email"
              >
                <b-form-input
                  id="coProdutor_email"
                  name="coProdutor_email"
                  v-model="coProdutor.user_id.email"
                  autocomplete="coProdutor_email"
                  type="text"
                  :placeholder="$t('seller.products.co_seller.text_1882')"
                  v-validate="'required|email|'"
                  v-on:input="debounce"
                  v-if="isObjectEmpty(selectedCoseller)"
                ></b-form-input>

                <b-form-input
                  id="coProdutor_email"
                  name="coProdutor_email"
                  v-model="selectedCoseller.user.email"
                  autocomplete="coProdutor_email"
                  type="text"
                  :placeholder="$t('seller.products.co_seller.text_1882')"
                  disabled
                  v-else
                ></b-form-input>
                <b-form-invalid-feedback
                  :state="!errors.has('coProdutor_email')"
                >
                  {{ $t('seller.products.co_seller.text_329') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col
              class="outros-dados"
              v-show="targetUser || !isObjectEmpty(selectedCoseller)"
              cols="12"
              data-anima="top"
            >
              <b-form-group
                :label="$t('seller.products.co_seller.text_1883')"
                class="mt-3"
                label-for="coProdutor_name"
              >
                <b-form-input
                  id="coProdutor_name"
                  name="coProdutor_name"
                  v-model="coProdutor.user.name"
                  type="text"
                  autocomplete="coProdutor_name"
                  :placeholder="$t('seller.products.co_seller.text_1883')"
                  v-validate="'required'"
                  :disabled="true"
                  v-if="isObjectEmpty(selectedCoseller)"
                ></b-form-input>

                <b-form-input
                  id="coProdutor_name"
                  name="coProdutor_name"
                  v-model="selectedCoseller.user.name"
                  type="text"
                  autocomplete="coProdutor_name"
                  :placeholder="$t('seller.products.co_seller.text_1883')"
                  v-validate="'required'"
                  :disabled="true"
                  v-else
                ></b-form-input>

                <b-form-invalid-feedback
                  :state="!errors.has('coProdutor_name')"
                >
                  {{ $t('seller.products.co_seller.text_1884') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <div class="flex-row mt-3">
                <b-col class="mr-4">
                  <b-form-group
                    :label="$t('seller.products.co_seller.text_1885')"
                    label-for="coProdutor_percentage"
                  >
                    <money
                      id="coProdutor_percentage"
                      name="coProdutor_percentage"
                      v-model="coProdutor.percentage"
                      placeholder="10,00"
                      v-bind="formatPercentage"
                      v-if="isObjectEmpty(selectedCoseller)"
                    ></money>
                    <money
                      id="coProdutor_percentage"
                      name="coProdutor_percentage"
                      v-model="selectedCoseller.percentage"
                      placeholder="10,00"
                      v-bind="formatPercentage"
                      v-else
                    ></money>

                    <b-form-invalid-feedback :state="errors.has('coProdutor_percentage')" v-if="isObjectEmpty(selectedCoseller) && isInvalidValue(coProdutor.percentage)">
                      {{ $t("views.seller.edit_product.text_2367") }}
                    </b-form-invalid-feedback>

                    <b-form-invalid-feedback :state="errors.has('coProdutor_percentage')" v-if="!isObjectEmpty(selectedCoseller) && isInvalidValue(selectedCoseller.percentage)">
                      {{ $t("views.seller.edit_product.text_2367") }}

                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group :label="$t('seller.products.co_seller.text_1886')" label-for="coProdutor_type">
                    <b-form-select
                      id="coProdutor_type"
                      name="coProdutor_type"
                      v-model="coProdutor.type"
                      :options="types"
                      v-validate="'required'"
                      v-if="isObjectEmpty(selectedCoseller)"
                    ></b-form-select>

                    <b-form-select
                      id="coProdutor_type"
                      name="coProdutor_type"
                      v-model="selectedCoseller.type"
                      :options="types"
                      disabled
                      v-validate="'required'"
                      v-else
                    ></b-form-select>
                    <b-form-invalid-feedback
                      :state="!errors.has('coProdutor_type')"
                    >
                      {{ $t('seller.products.co_seller.text_1887') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
      <div class="mt-5 container-loading" v-if="loading">
        <b-spinner label="Loading..."></b-spinner>
      </div>
    </b-row>

    <template v-slot:footer="{ cancel }">
      <BaseButton
        :disabled="loading || submit"
        variant="secondary_outline"
        class="mr-4"
        @click="cancel"
      >
        {{ $t('seller.products.co_seller.text_1888') }}
      </BaseButton>

      <div id="adicionar-salvar">
        <BaseButton
          variant="link-info"
          @click="onSubmit"          
          v-if="isObjectEmpty(selectedCoseller)"
          :disabled="loading || submit || !coProdutor.user.name || isInvalidValue(coProdutor.percentage)"
        >
          {{ $t('seller.products.co_seller.text_1890') }}
        </BaseButton>

        <BaseButton
          variant="link-info"
          @click="onUpdate"
          v-else
          :disabled="loading || submit || isInvalidValue(selectedCoseller.percentage)"

        >
          {{ $t('seller.products.co_seller.text_1889') }}
        </BaseButton>
      </div>
      <b-tooltip
        v-if="!coProdutor.user.name && isObjectEmpty(selectedCoseller)"
        target="adicionar-salvar"
        :title="$t('seller.products.co_seller.text_328')"
      />
    </template>
  </BaseModal>
</template>
<script>
import CoSellerService from "@/services/resources/CoSellerService";
const serviceCoSeller = CoSellerService.build();
import UsersCoSellerService from "@/services/resources/UsersCoSellerService";
const serviceUsersCoSeller = UsersCoSellerService.build();
import _ from "lodash";

import { Money } from "v-money";

export default {
  components: {
    Money,
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    product: {
      type: Object,
      default() {
        return {};
      },
    },
    product_id: {
      type: Object,
      default() {
        return {};
      },
    },
    selectedCoseller: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      error_percentage: false,
      formatPercentage: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: " %",
        precision: 2,
        masked: false,
      },
      regex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      targetUser: false,

      coProdutor: {
        percentage: 0,
        type: "ALL",
        user: { name: "" },
        user_id: {
          id: "",
          name: "",
          email: "",
        },
      },
      loading: false,
      coSellersComp: [
        {
          user_id: null,
          percentage: null,
          type: "ALL",
        },
      ],
      types: [
        { value: "ALL", text: this.$t('seller.products.co_seller.text_331') },
        { value: "AFFILIATE", text: this.$t('seller.products.co_seller.text_332') },
        { value: "NOT_AFFILIATE", text: this.$t('seller.products.co_seller.text_333') },
        { value: "MANAGER_AFFILIATE", text: this.$t('seller.products.co_seller.text_334') },
      ],
      submit: false,
      users: [],
      product_target_id: null,
    };
  },
  watch: {
    "coProdutor.percentage"(value) {       
      if (value >= 100 || value < 0) {
        this.coProdutor.percentage = 0;
        this.error_percentage = true;
        }
      
    },
    "selectedCoseller.percentage"(value) {
      if (value >= 100 || value < 0) {
        this.selectedCoseller.percentage = 0;
        this.error_percentage = true;
      }
    },
  },
  computed: {
    coSellers: {
      get() {
        if (this.coSellersComp.length) return this.coSellersComp;
        else if (this.data.length) return this.data;

        return [
          {
            user_id: null,
            percentage: null,
            type: "ALL",
          },
        ];
      },
      set(value) {
        this.coSellersComp = value;
      },
    },
  },

  methods: {
    isInvalidValue(value) {
      return value < 0.01 || !value;
    },
    debounce: _.debounce(function() {
      // this.initEmail();
      this.fetchUsers(this.coProdutor.user_id.email);
    }, 1000),
    updateCoSeller() {
      const targetCoSeller = {
        user_id: this.selectedCoseller.user_id,
        percentage: +this.selectedCoseller.percentage,
        type: this.selectedCoseller.type,
      };

      const filteredCoSellers = this.product_id.co_sellers.filter(
        coSeller => coSeller.user_id !== targetCoSeller.user_id
      );

      this.validatePercentage([
        ...filteredCoSellers,
        targetCoSeller,
      ]).then((validate) => {
        if (validate) {
          this.product_target_id = +this.product_id.id.toString();
          const dataUpdate = {
            id: this.selectedCoseller.id,
            percentage: +this.selectedCoseller.percentage,
          };
          serviceCoSeller
            .update(dataUpdate)
            .then((response) => {
              document
                .querySelector("#coProdutor_percentage")
                .classList.remove("erro");

              this.coProdutor.id = response.id;
              this.$emit("added", [this.coProdutor]);
              this.$bvModal.hide("product-co-sellers");
              this.coSellersComp = [];
              this.targetUser = false;
              this.coProdutor = {
                percentage: "",
                type: "ALL",
                user: { name: "" },
                user_id: {},
              };

              this.$bvToast.toast(this.$t('seller.products.co_seller.edit_co_seller_success'), {
                title: this.$t('seller.products.co_seller.text_1891'),
                variant: "success",
                autoHideDelay: 5000,
                appendToast: true,
              });
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.submit = false;
            });
        } else {
          if (document.querySelector("#coProdutor_percentage")) {
            document.querySelector("#coProdutor_percentage").focus();
          }
          document
            .querySelector("#coProdutor_percentage")
            .classList.add("erro");

          this.$bvToast.toast(
           this.$t('seller.products.co_seller.text_336'),
            {
              title: this.$t('seller.products.co_seller.text_1892'),
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
          this.submit = false;
        }

      })      
    },
    createCoSeller() {
      const targetCoSeller = {
        user_id: this.coProdutor.user_id.id,
        percentage: +this.coProdutor.percentage,
        type: this.coProdutor.type,
      };

      this.validatePercentage([
        ...this.product_id.co_sellers,
        targetCoSeller,
      ]).then((validate) => {
        if (validate) {
          this.product_target_id = +this.product_id.id.toString();
          const dataUpdate = {
            product_id: this.product_target_id,
            user_id: this.coProdutor.user_id.id,
            percentage: +this.coProdutor.percentage,
            type: this.coProdutor.type,
          };
          serviceCoSeller
            .create(dataUpdate)
            .then((response) => {
              document
                .querySelector("#coProdutor_percentage")
                .classList.remove("erro");

              this.coProdutor.id = response.id;
              this.$emit("added", [this.coProdutor]);
              this.$bvModal.hide("product-co-sellers");
              this.coSellersComp = [];
              this.targetUser = false;
              this.coProdutor = {
                percentage: "",
                type: "ALL",
                user: { name: "" },
                user_id: {},
              };

              this.$bvToast.toast(this.$t('seller.products.co_seller.text_335'), {
                title: this.$t('seller.products.co_seller.text_1891'),
                variant: "success",
                autoHideDelay: 5000,
                appendToast: true,
              });
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.submit = false;
            });
        } else {
          if (document.querySelector("#coProdutor_percentage")) {
            document.querySelector("#coProdutor_percentage").focus();
          }
          document
            .querySelector("#coProdutor_percentage")
            .classList.add("erro");

          this.$bvToast.toast(
           this.$t('seller.products.co_seller.text_336'),
            {
              title: this.$t('seller.products.co_seller.text_1892'),
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
          this.submit = false;
        }
      });
    },
    isInvalidValue(value) {
      return value < 0.01 || !value;
    },
    addCoSeller() {
      this.coSellersComp.push({
        user_id: null,
        percentage: null,
        type: "ALL",
        user: {
          name: "",
        },
      });
    },
    remove(index) {
      if (this.coSellers.length > 1) {
        this.$delete(this.coSellers, index);
      }
    },
    mountedCoseller(coSeller) {
      this.coProdutor.user.name = "";
      this.coProdutor.user_id.id = "";
      if (coSeller.length) {
        this.loading = false;
        this.targetUser = true;
        this.coProdutor.user.name = coSeller[0].name;
        this.coProdutor.user_id.id = coSeller[0].id;
        setTimeout(() => {
          if (document.querySelector("#coProdutor_percentage"))
            document.querySelector("#coProdutor_percentage").focus();
        }, 1000);
      } else {
        this.loading = false;
        this.targetUser = false;

        this.$bvToast.toast(
          this.$t('seller.products.co_seller.text_337'),
          {
            title: this.$t('seller.products.co_seller.text_1892'),
            variant: "danger",
            autoHideDelay: 8000,
            appendToast: true,
          }
        );

        setTimeout(() => {
          if (document.querySelector("#coProdutor_email"))
            document.querySelector("#coProdutor_email").classList.add("erro");
        }, 1000);
      }
    },
    fetchUsers(email_coseller) {
      if (this.coProdutor.user_id.email.length > 10) {
        if (this.regex.test(this.coProdutor.user_id.email)) {
          let data = {
            search: email_coseller,
          };
          document.querySelector("#coProdutor_email").classList.remove("erro");

          this.loading = true;
          serviceUsersCoSeller
            .search(data)
            .then((response) => {
              this.mountedCoseller(response);
            })
            .catch((err) => {
              console.log(err);
              this.mountedCoseller([]);
            });
        }
      }
    },
    onSubmit() {
      this.submit = true;
      this.coProdutor.user_id.email = this.coProdutor.user_id.email.trim();

      if (this.coProdutor.percentage <= 100) {
        this.error_percentage = false;
      } else {
        this.$bvToast.toast(this.$t('seller.products.co_seller.text_338'), {
          title: this.$t('seller.products.co_seller.text_1892'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
        this.loading = false;
        this.submit = false;
        return false;
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createCoSeller();
        } else {
          this.loading = false;
          this.submit = false;
        }
      });
    },
    onUpdate() {
      this.submit = true;

      if (this.coProdutor.percentage <= 100) {
        this.error_percentage = false;
      } else {
        this.$bvToast.toast(this.$t('seller.products.co_seller.text_338'), {
          title: this.$t('seller.products.co_seller.text_1892'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
        this.loading = false;
        this.submit = false;
        return false;
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateCoSeller();
        } else {
          this.loading = false;
          this.submit = false;
        }
      });
    },
    validatePercentage(moreSeller) {
      return new Promise((resolve) => {
        const allCoSeller = moreSeller;

        if (allCoSeller) {
          let total = 0;
          for (let i = 0; i < allCoSeller.length; i++) {
            total += allCoSeller[i].percentage;
          }
          if (allCoSeller[0].type == "PRODUTOR") {
            total = total - allCoSeller[0].percentage;
          }

          if (total > 100) {
            resolve(false);
          } else {
            resolve(true);
          }
        }
      });
    },
    isObjectEmpty(obj) {
      return !(obj && Object.keys(obj)?.length > 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-remover {
  display: flex;
  align-items: center;
  font-size: 13px;
  padding: 5px 20px;
  margin: 10px 0;
  margin-left: auto;
}
.btn-remover img {
  width: 15px;
  margin-right: 10px;
  filter: brightness(0) invert(1);
}
.flex-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.novo-Coprodutor {
  font-size: 13px;
  padding: 10px 20px;
  margin: 20px auto;
  display: flex;
  align-items: center;
}
.item-campos {
  padding: 20px 0;
}
.item-campos + .item-campos {
  border-top: 1px solid #ededf0;
}

.produto-nome {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 30px;
  color: $black;
}
</style>
